module.exports = __webpack_public_path__ + "img/testimonials-1.2eb96321.jpg";